module.exports = __webpack_public_path__ + "img/logo-corfo-134x56.fefb4a1e.png";